import Logo from "./Logo";
import NavButton from "./NavButton";
import NavigatorButtons from "./NavigatorButtons";
import Modal from "./Modal";
import { useDispatch, useSelector } from "react-redux";
import SocialLinks from "./SocialLinks";
import { setActiveSection } from "../../store";
import classNames from "classnames";

function TopNav({
  aboutRef,
  worksRef,
  experienceRef,
  contactRef,
  preventIntersectionObserver,
}) {
  const dispatch = useDispatch();
  const {
    activeProject,
    showResumeLink,
    activeSection,
    makeResumeLinkFlashy,
    resumeLink,
  } = useSelector((state) => state.app);

  return (
    <div className="h-[60px] w-screen nav-background border-b-2 border-black flex flex-row items-center pl-3 sticky left-0 z-40">
      <Logo />
      <div className="grow flex flex-row justify-center items-center sticky left-0 -z-10">
        {showResumeLink && (
          <div
            className={classNames(
              "flex flex-row justify-start w-[170px] items-center font-bold",
              {
                "resume-link-anim-flashy": makeResumeLinkFlashy,
                "resume-link-anim": !makeResumeLinkFlashy,
              }
            )}
          >
            <a
              href={resumeLink}
              target="_blank"
              className="mr-2 hover:mr-4 cursor-pointer hover-black-underline transition-[margin]"
              rel="noreferrer"
            >
              View Full Résumé
            </a>
            <div
              className={classNames({
                "arrow-resume-anim-flashy": makeResumeLinkFlashy,
                "arrow-resume-anim": !makeResumeLinkFlashy,
              })}
            >
              <svg
                width="22"
                height="8"
                viewBox="0 0 22 8"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.3536 4.35355C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464466C17.9763 0.269204 17.6597 0.269204 17.4645 0.464466C17.2692 0.659728 17.2692 0.976311 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53553C17.6597 7.7308 17.9763 7.7308 18.1716 7.53553L21.3536 4.35355ZM0 4.5H21V3.5H0V4.5Z"
                  strokeWidth="20px"
                />
              </svg>
            </div>
          </div>
        )}
      </div>
      <NavigatorButtons>
        <NavButton
          text="About"
          selected={activeSection === "about"}
          onClick={() => {
            dispatch(setActiveSection("about"));
            preventIntersectionObserver.current = true;
            aboutRef.current.scrollIntoView({
              behavior: "smooth",
              inline: "start",
            });
            /**
             * This delay is needed to keep intersection observers disables while scrolling
             * animation plays.
             */
            setTimeout(() => {
              preventIntersectionObserver.current = false;
            }, 300);
          }}
        />
        <NavButton
          text="Works"
          selected={activeSection === "works"}
          onClick={() => {
            dispatch(setActiveSection("works"));
            preventIntersectionObserver.current = true;
            worksRef.current.scrollIntoView({
              behavior: "smooth",
              inline: "start",
            });
            /**
             * This delay is needed to keep intersection observers disables while scrolling
             * animation plays.
             */
            setTimeout(() => {
              preventIntersectionObserver.current = false;
            }, 300);
          }}
        />
        <NavButton
          text="Experience"
          selected={activeSection === "experience"}
          onClick={() => {
            dispatch(setActiveSection("experience"));
            preventIntersectionObserver.current = true;
            experienceRef.current.scrollIntoView({
              behavior: "smooth",
              inline: "start",
            });
            /**
             * This delay is needed to keep intersection observers disables while scrolling
             * animation plays.
             */
            setTimeout(() => {
              preventIntersectionObserver.current = false;
            }, 300);
          }}
        />
        <NavButton
          text="Contact"
          selected={activeSection === "contact"}
          onClick={() => {
            dispatch(setActiveSection("contact"));
            preventIntersectionObserver.current = true;
            contactRef.current.scrollIntoView({
              behavior: "smooth",
              inline: "start",
            });
            /**
             * This delay is needed to keep intersection observers disables while scrolling
             * animation plays.
             */
            setTimeout(() => {
              preventIntersectionObserver.current = false;
            }, 300);
          }}
        />
      </NavigatorButtons>
      <SocialLinks />
      {Number.isInteger(activeProject) && (
        <div
          className="fixed left-0 top-0 w-screen h-full z-40"
          style={{ backgroundColor: "rgba(217, 217, 217, 0.89)" }}
          onWheel={(e) => e.stopPropagation()}
        >
          <Modal />
        </div>
      )}
    </div>
  );
}

export default TopNav;
